import { Link } from 'wouter-preact';
import { useAuth } from '../lib/session';

/**
 * Signed-in account affordance for the map shell (issue #10): a round
 * initial-letter button in the corner-controls cluster linking to
 * /account. Renders nothing while signed out or while /auth/me is still
 * resolving — the "Report litter" FAB owns the sign-in entry point; the
 * gap this closes is the absence of any signed-IN indicator, which left
 * /account (and sign-out, and deletion) reachable only by typing URLs.
 *
 * Reads the shared useAuth() signal only and must never fetch on its
 * own: ContributeFab already subscribes on this page, and an Aurora
 * resume can hold a fresh /auth/me call for ~20s.
 *
 * A direct link, not a menu: the account page already aggregates
 * everything a menu would list, and deletion findability wants a plain
 * navigable path (see the src/pages/account.tsx header).
 */
export function AccountCornerButton() {
  const { user } = useAuth();
  if (!user) return null;

  const source = user.display_name?.trim() || user.email.trim();
  const initial = source ? source.charAt(0).toUpperCase() : '?';

  return (
    <div class="map-corner-controls__item">
      <Link
        href="/account"
        class="map-corner-controls__btn map-corner-controls__btn--account"
        aria-label="Account"
      >
        <span aria-hidden="true">{initial}</span>
      </Link>
      <span class="map-corner-controls__caption" aria-hidden="true">
        Account
      </span>
    </div>
  );
}
